import React, { useState } from 'react';
import './Cars.css';

// const carImages = require.context('../../Assets/img/car', true);
const carImages = require.context('../../Assets/img', true);
// Get the keys of the images
const imageKeys = carImages.keys();
// Map the keys to get the images and their filenames
const CarsLogo = imageKeys.map((key, index) => ({
  id: index + 1,
  Brand: key.replace('./', '').replace('.png', '').toUpperCase(), // Extracting brand name from filename
  Logo: carImages(key),
  Cars: ['https://imgd.aeplcdn.com/370x208/n/cw/ec/141867/nexon-exterior-right-front-three-quarter-71.jpeg?isig=0'] // Placeholder URL
}));


console.log(CarsLogo);

export default function Cars() {
  const key = ['Brand'];

  function Search(data, search) {
    return data.filter((item) =>
      key.some((key) => item[key].toLowerCase().includes(search.toLowerCase()))
    );
  }

  const [search, setSearch] = useState("");

  return (
    <div className='carContainer' id='carSection'>
      <h2 className='CarsHeading'>Some famous Companies we Repaired </h2>
      <div className='selectCars'>
        <input
          type="search"
          placeholder='Search Your Car'
          value={search}
          className='searchBar'
          onChange={(e) => setSearch(e.target.value)}
        />
        <ul className='carList'>
          {Search(CarsLogo, search).map((item) => (
            <li className='carListItem' key={item.id}>
              <label className='label' htmlFor="carLogo">{item.Brand}</label>
              <img className='carLogo' src={item.Logo} alt="" />
            </li>
          ))}
        </ul>
         
      </div>
    </div>
  );
}